import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
const icons = { HomeRoundedIcon };

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard-revenue',
      activePaths: ['/dashboard-revenue', '/dashboard-expense', '/dashboard-asset'],
      icon: icons.HomeRoundedIcon
    }
  ]
};

export default dashboard;
